import React from 'react';
import PageWrapper from '@/components/ui/PageWrapper';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const About = () => {
  return (
    <PageWrapper>
      {/* Hero Section */}
      <div className="relative py-32 bg-primary overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1601362840469-51e4d8d58785?auto=format&fit=crop&q=80')] bg-cover bg-center opacity-10"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 flex flex-col items-center text-center">
          <span className="text-accent text-sm font-bold tracking-widest uppercase mb-4">Our Story</span>
          <h1 className="text-5xl md:text-7xl font-heading font-bold mb-6">Driven by Perfection</h1>
          <p className="text-xl text-textMuted max-w-3xl">
            Founded by automotive enthusiasts, Obsidian Auto Spa exists to elevate the standard of vehicle care in Montreal.
          </p>
        </div>
      </div>

      {/* Content Section */}
      <div className="py-24 bg-bgDark">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div 
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="space-y-6"
            >
              <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6">More Than Just a Wash. An Obsession.</h2>
              <p className="text-textMuted leading-relaxed">
                What started as a personal passion for preserving exotic cars in a small garage has grown into Montreal's premier detailing studio. We realized that standard car washes were inducing damage, and traditional "detailers" were merely covering up defects with cheap glazes.
              </p>
              <p className="text-textMuted leading-relaxed">
                At Obsidian Auto Spa, we take a scientific approach to paint correction and protection. We measure paint thickness, utilize specialized lighting to spot microscopic defects, and apply aerospace-grade ceramic coatings to lock in perfection.
              </p>
              <p className="text-textMuted leading-relaxed font-medium text-textLight">
                We don't work on volume; we work on quality. Every vehicle that rolls into our studio is treated with the absolute highest level of respect and meticulous care.
              </p>
              
              <div className="grid grid-cols-2 gap-8 pt-8 mt-8 border-t border-white/10">
                <div>
                  <h4 className="text-4xl font-heading font-bold text-accent mb-2">10+</h4>
                  <p className="text-sm text-textMuted uppercase tracking-wider">Years Experience</p>
                </div>
                <div>
                  <h4 className="text-4xl font-heading font-bold text-accent mb-2">2k+</h4>
                  <p className="text-sm text-textMuted uppercase tracking-wider">Vehicles Protected</p>
                </div>
              </div>
            </motion.div>

            <motion.div 
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/10"
            >
              <img src="https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?auto=format&fit=crop&q=80" alt="Detailing Studio" className="w-full h-auto object-cover" />
              <div className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-black to-transparent">
                <div className="flex items-center gap-3">
                  <SafeIcon icon={FiIcons.FiMapPin} className="text-accent text-xl" />
                  <span className="font-heading text-lg font-medium">Montreal, QC Premium Studio</span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default About;